$(function() {
  $(".ebay-listing-form").submit();
  $(".tcgplayer-price-widget-form").submit();
  $(".cardkingdom-price-widget-form").submit();

  $(".logged_in-modal").on("show.bs.modal", function(e) {
    if ($("#logged_in").length == 0) {
      e.preventDefault();
      var id = $(this).attr('id');
      var url = window.location.href.split("#")[0];
      url = url + "#" + id;
      $(".login-override_origin").val(url);
      $("#login-modal").modal('show');
    }
  });


  $(document).on('change', '.form-submit-on-change', function(){
    $(this).closest("form").submit();
  });

});

function initializeCardPriceHistoryComponent(tabId, cardId, priceType) {
  var type = "";
  $(document).on('shown.bs.tab', `#${tabId} a[data-toggle="tab"]`, function(e) {
    var tab = $(e.target.hash);
    if (tab.data("price-history-component") && !tab.data("loaded")) {
      type = tab.data("type");
      // send AJAX request
      $.ajax({
        url: '/price_history_component',
        dataType: "script",
        data: {
          card_id: cardId,
          selector: e.target.hash,
          type: type,
          price_type: priceType,
        },
        context: this,
      });
    }
  })
}
window.initializeCardPriceHistoryComponent = initializeCardPriceHistoryComponent
